import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown w-250px w-md-600px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "px-7 py-5" }
const _hoisted_3 = { class: "fs-5 text-dark fw-bolder" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_5 = { class: "px-7 py-5 mh-400px scroll-y" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-md-6 form-group mb-7" }
const _hoisted_8 = { class: "form-label fw-bold" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mb-7" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" })
], -1)
const _hoisted_10 = { class: "col-md-6 form-group mb-7" }
const _hoisted_11 = { class: "form-label fw-bold" }
const _hoisted_12 = { class: "col-md-6 form-group mb-7" }
const _hoisted_13 = { class: "form-label fw-bold" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 mb-7" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" })
], -1)
const _hoisted_15 = { class: "col-md-6 form-group mb-7" }
const _hoisted_16 = { class: "form-label fw-bold" }
const _hoisted_17 = { class: "col-md-6 form-group mb-7" }
const _hoisted_18 = { class: "form-label fw-bold" }
const _hoisted_19 = { class: "col-md-6 form-group mb-7" }
const _hoisted_20 = { class: "form-label fw-bold" }
const _hoisted_21 = { class: "col-md-6 form-group mb-7" }
const _hoisted_22 = { class: "form-label fw-bold" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("div", { class: "separator border-gray-200" }, null, -1)
const _hoisted_24 = { class: "px-7 py-5 d-flex justify-content-end gap-2" }
const _hoisted_25 = { class: "svg-icon svg-icon-3" }
const _hoisted_26 = {
  type: "submit",
  class: "btn btn-primary",
  "data-kt-menu-dismiss": "true"
}
const _hoisted_27 = { class: "svg-icon svg-icon-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_inline_svg_icon = _resolveComponent("inline-svg-icon")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_form, {
      ref: "formRef",
      onSubmit: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
      model: _ctx.formData
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.t("common.filterOptions")), 1)
        ]),
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.t("finacialReport.osInvoiceStatus")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "status" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    class: "w-100",
                    modelValue: _ctx.formData.status,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.status) = $event)),
                    clearable: "",
                    placeholder: _ctx.t('common.plsSelect')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.statusOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.t("finacialReport.entity")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "debtor_entity_id" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    class: "w-100",
                    modelValue: _ctx.formData.debtor_entity_id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.debtor_entity_id) = $event)),
                    filterable: "",
                    clearable: "",
                    "remote-show-suffix": "",
                    remote: "",
                    "remote-method": _ctx.searchEntityItems,
                    loading: _ctx.options.entityLoading,
                    placeholder: _ctx.t('common.plsSelect')
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options.entityOptions, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.id,
                          label: item.name,
                          value: item.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "remote-method", "loading", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.t("finacialReport.creditNo")) + ":", 1),
              _createVNode(_component_el_form_item, {
                prop: "creditor_entity_id",
                onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.formData.creditor_entity_id,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.creditor_entity_id) = $event)),
                    type: "text",
                    placeholder: _ctx.t('common.plsEnter'),
                    clearable: ""
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("label", _hoisted_16, _toDisplayString(_ctx.t("finacialReport.osInvoiceAtStart")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "invoice_date_start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    class: "w-100",
                    modelValue: _ctx.formData.invoice_date_start,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.invoice_date_start) = $event)),
                    type: "date",
                    placeholder: _ctx.t('common.pickDate'),
                    format: "DD.MM.YYYY"
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.t("finacialReport.osInvoiceAtEnd")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "invoice_date_end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    class: "w-100",
                    modelValue: _ctx.formData.invoice_date_end,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.invoice_date_end) = $event)),
                    type: "date",
                    placeholder: _ctx.t('common.pickDate'),
                    format: "DD.MM.YYYY"
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.t("finacialReport.osOrderDateStart")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "order_date_start" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    class: "w-100",
                    modelValue: _ctx.formData.order_date_start,
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.formData.order_date_start) = $event)),
                    type: "date",
                    placeholder: _ctx.t('common.pickDate'),
                    format: "DD.MM.YYYY"
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.t("finacialReport.osOrderDateEnd")) + ":", 1),
              _createVNode(_component_el_form_item, { prop: "order_date_end" }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_date_picker, {
                    class: "w-100",
                    modelValue: _ctx.formData.order_date_end,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.order_date_end) = $event)),
                    type: "date",
                    placeholder: _ctx.t('common.pickDate'),
                    format: "DD.MM.YYYY"
                  }, null, 8, ["modelValue", "placeholder"])
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _hoisted_23,
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("button", {
            type: "reset",
            class: "btn btn-light",
            "data-kt-menu-dismiss": "true",
            onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleReset && _ctx.handleReset(...args)))
          }, [
            _createElementVNode("span", _hoisted_25, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr059.svg" })
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.t("common.reset")), 1)
          ]),
          _createElementVNode("button", _hoisted_26, [
            _createElementVNode("span", _hoisted_27, [
              _createVNode(_component_inline_svg_icon, { src: "media/icons/duotune/arrows/arr064.svg" })
            ]),
            _createTextVNode(" " + _toDisplayString(_ctx.t("common.apply")), 1)
          ])
        ])
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}